<template>
    <div class="">
        <el-dialog v-model="registrationPopup" title="报名信息" width="50%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
                label-position="right">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="姓名" prop="userName">
                            <el-input disabled v-model="ruleForm.userName" placeholder="请输入姓名" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="账户名称" prop="bankAccountName">
                            <el-input disabled v-model="ruleForm.bankAccountName" placeholder="请输入账户名称" />
                        </el-form-item>
                    </el-col>
                  <el-col :span="8" >
                    <el-form-item label="开户行名称" prop="bankName">
                      <el-input disabled v-model="ruleForm.bankName" placeholder="请输入开户行名称" />
                    </el-form-item>
                  </el-col>
                    <el-col :span="8">
                        <el-form-item label="银行卡号" prop="bankNo">
                            <el-input disabled v-model="ruleForm.bankNo" placeholder="请输入银行卡号" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="证件号" prop="userCode">
                            <el-input disabled v-model="ruleForm.userCode" placeholder="请输入证件号" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系电话" prop="userPhone">
                            <el-input disabled v-model="ruleForm.userPhone" placeholder="请输入联系电话" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="上传付款凭证" prop="fileName">
                            <el-upload class="upload-demo" :show-file-list="false" accept="image/jpeg,image/png,image/gif" :headers="headers"
                                action="/api/common/upload" multiple :before-upload="beforeUpload"
                                :on-success="handleSuccess" :limit-size="3 * 1024 * 1024">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        附件大小最大为3MB
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
              <el-row :gutter="24">
                <el-form-item label="付款凭证" prop="fileName">
                  <div class="attachment_box" v-for="(items, index) in ruleForm.fileList">
                    <div class="mr20 close_icon color_fff flex_end">
                      <el-icon @click="closeFile(index)">
                        <CloseBold />
                      </el-icon>
                    </div>
                    <div class="attachment_info flex_center">
                      <el-image style="width: 150px; height: 150px" :src="items.url"
                                :preview-src-list="[items.url]" fit="contain" />
                    </div>
                  </div>
                </el-form-item>
              </el-row>

            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="getProjectSign">
                        立即报名
                    </el-button>
                    <el-button @click="registrationPopup = false">取消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { projectSign, realNameInfo, signReply, projectGoSignVerify } from "@/utils/api";
export default {
    components: {
    },
    data() {
        return {
            registrationPopup: false,
            ruleForm: {
                id: "",
                projectId: "",
                userName: "",
                bankAccountName: "",
                bankNo: "",
                bankName: "",
                userCode: "",
                userPhone: "",
                fileList: [],
            },
            rules: {
                userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                bankAccountName: [{ required: true, message: "请输入账户名称", trigger: "blur" }],
                bankName: [{ required: true, message: "请输入开户行名称", trigger: "blur" }],
                bankNo: [{ required: true, message: "请输入银行卡号", trigger: "blur" }],
                userCode: [{ required: true, message: "请输入证件号", trigger: "blur" }],
                userPhone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
            },

            headers: {
                Authorization: "Bearer " + localStorage.token,
                'Access-Control-Allow-Origin': '*'
            },
        }
    },
    mounted() {
    },
    methods: {

        beforeUpload(file) {
            const maxSize = 3 * 1024 * 1024;
            if (file.size > maxSize) {
                this.$message({
                    message: "附件大小限制为3MB",
                    type: "error",
                });
                return false;
            }
            return true;
        },

        handleSuccess(res, uploadFile, uploadFiles) {
            this.ruleForm.fileList.push({
                fileName: res.fileName,
                newFileName: res.newFileName,
                url: res.url,
                originalFilename: res.originalFilename,
            })
        },

        closeFile(index) {
            this.ruleForm.fileList.splice(index, 1);
        },
        // 打开弹窗
        openPopup(id, row) {
          if (row) {
            this.ruleForm = row;
            this.registrationPopup = true;
            return;
          }
            projectGoSignVerify({ projectId: id }).then((res) => {
                if (res.code == 200) {
                    if (res.data.code == 1) {
                        this.ruleForm = res.data.xhProjectApply;
                        this.registrationPopup = true;
                    } else if (res.data.code == 2) {
                        this.$message({
                            message: "请联系客服缴纳该项目保证金后进行报名操作，如已缴纳，请耐心等待保证金审核通过",
                            type: "warning"
                        });
                    }else if (res.data.code == 3) {
                        this.ruleForm = res.data.xhProjectApply;
                        this.registrationPopup = true;
                    } else if (res.data.code == 4) {
                        this.$message({
                            message: "您已报名过该项目 无需重复报名 请在个人中心查看报名信息审核状态",
                            type: "warning"
                        });
                    } else if (res.data.code == 5) {
                        this.$message({
                            message: "请勿对自己的项目报名",
                            type: "warning"
                        });
                    }else if (res.data.code == 6) {
                      this.$message({
                        message: "保证金已退回,无法报名",
                        type: "warning"
                      });
                    } else if (res.data.code == 7) {
                      this.$message({
                        message: "不在该项目报名时间范围内,无法报名",
                        type: "warning"
                      });
                    }

                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            });
        },
        // 立即报名
        async getProjectSign() {
            if (!/^1[3456789]\d{9}$/.test(this.ruleForm.userPhone)) {
                this.$message.error("联系电话有误，请重填");
                return;
            }

            if (!/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test(this.ruleForm.userCode)) {
                this.$message.error("证件号有误，请重填");
                return;
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // 表单验证通过，执行后续操作，比如提交数据到后端等
                    console.log('表单验证通过');
                    console.log(this.ruleForm.id);
                    if (this.ruleForm.id > 0) {
                        this.updateForm();
                    } else {
                        this.submitForm();
                    }

                }
            });
        },
        async submitForm() {
            let res = await projectSign(this.ruleForm);
            if (res.code == 200) {
                this.$message({
                    message: res.msg,
                    type: "success",
                });
                this.registrationPopup = false;
            } else {
                this.$message({
                    message: res.msg,
                    type: "error",
                });
            }
        },

        async updateForm() {
            let res = await signReply(this.ruleForm);
            if (res.code == 200) {
                this.$message({
                    message: res.msg,
                    type: "success",
                });
                this.registrationPopup = false;
                this.$emit("refreshList", true);
            } else {
                this.$message({
                    message: res.msg,
                    type: "error",
                });
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.attachment_list {
  display: flex;
  align-items: center;
}
.attachment_box {
  font-size: 15px;
    // align-items: flex-end;
}

.attachment_info {
  width: 80px;
  height: 80px;
  background-color: bisque;
  margin-top: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-right: 20px;
}
.close_icon {
  position: relative;
  z-index: 1;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #000;
  margin-right: 20px;
}
</style>
